import { h, Component } from 'preact';
import check from '../../img/check.png';
import check2 from '../../img/check@2x.png';
import check3 from '../../img/check@3x.png';

export class CheckboxWithLabel extends Component {
    render({action, checked, label},{}) {
        return(
            <div className='checkbox-wrapper' onClick={action}>
                <div className='checkbox-icon'>
                    <img src={check} srcSet={`${check2} 2x, ${check3} 3x`}
                         alt={'checkbox'} className={`${checked ? '' : 'hidden'}`} />
                </div>
                <label>{label}</label>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/@webapp/preact-shared/components/checkbox-with-label/checkbox-with-label.js